import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "today-hero ion-padding" }
const _hoisted_2 = { class: "today-hero-inner" }
const _hoisted_3 = { class: "today-brand" }
const _hoisted_4 = { class: "today-title-wrap" }
const _hoisted_5 = { class: "today-hero-sub" }
const _hoisted_6 = {
  key: 0,
  class: "today-section today-section-events"
}
const _hoisted_7 = {
  ref: "eventsScrollWrap",
  class: "today-scroll-wrap"
}
const _hoisted_8 = { class: "today-scroll" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "today-event-title" }
const _hoisted_12 = { class: "today-event-meta" }
const _hoisted_13 = { class: "today-event-loc" }
const _hoisted_14 = { class: "today-event-badges" }
const _hoisted_15 = {
  key: 0,
  class: "today-badge today-badge--paid"
}
const _hoisted_16 = {
  key: 1,
  class: "today-badge today-badge--soldout"
}
const _hoisted_17 = {
  key: 2,
  class: "today-badge today-badge--registered"
}
const _hoisted_18 = {
  key: 0,
  class: "today-footer-link"
}
const _hoisted_19 = {
  key: 1,
  class: "today-empty"
}
const _hoisted_20 = {
  key: 1,
  class: "today-section"
}
const _hoisted_21 = { class: "today-scroll-wrap" }
const _hoisted_22 = { class: "today-scroll" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "today-program-cover" }
const _hoisted_25 = {
  key: 0,
  class: "today-program-skeleton-wrap"
}
const _hoisted_26 = ["src", "alt", "onLoad", "onError"]
const _hoisted_27 = { class: "today-program-name" }
const _hoisted_28 = { class: "today-program-desc" }
const _hoisted_29 = {
  key: 2,
  class: "today-section today-section--last"
}
const _hoisted_30 = {
  key: 0,
  class: "today-empty-inline"
}
const _hoisted_31 = {
  key: 1,
  class: "today-scroll-wrap"
}
const _hoisted_32 = { class: "today-scroll" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  class: "today-edu-icon",
  "aria-hidden": "true"
}
const _hoisted_35 = { class: "today-edu-title" }
const _hoisted_36 = {
  key: 2,
  class: "today-scroll-wrap"
}
const _hoisted_37 = { class: "today-scroll" }
const _hoisted_38 = {
  key: 3,
  class: "today-offline ion-padding"
}
const _hoisted_39 = { class: "today-offline-panel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: _normalizeClass(['main-background', 'today-content', 'today-showcase-bg']),
        fullscreen: true,
        "scroll-y": true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _ctx.onRefresh
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content, { refreshingSpinner: "bubbles" })
            ]),
            _: 1
          }, 8, ["onIonRefresh"]),
          _createElementVNode("div", _hoisted_1, [
            _cache[3] || (_cache[3] = _createElementVNode("div", {
              class: "today-hero-glow",
              "aria-hidden": "true"
            }, null, -1)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_ion_button, {
                  class: "today-menu-btn",
                  fill: "clear",
                  size: "small",
                  "aria-label": "Открыть меню",
                  onClick: _ctx.openMainMenu
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.menuOutline }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createElementVNode("div", _hoisted_4, [
                  _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "today-hero-title" }, "Сегодня", -1)),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.now), 1)
                ])
              ])
            ])
          ]),
          (!_ctx.globalContext.offlineMode && _ctx.isAuthenticated)
            ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "today-section-head" }, [
                  _createElementVNode("span", {
                    class: "today-section-accent",
                    "aria-hidden": "true"
                  }),
                  _createElementVNode("h2", { class: "today-section-title" }, "События")
                ], -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upcomingEvents, (ev) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: ev.id,
                        class: "today-event-card",
                        onClick: ($event: any) => (_ctx.$router.push(`/events/${ev.id}`))
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["today-event-image-wrap", { 'today-event-image-wrap--no-logo': !ev.logoPath }])
                        }, [
                          (ev.logoPath)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.eventsService.logoUrl(ev.logoPath, 480),
                                alt: ev.title,
                                class: "today-event-img",
                                loading: "lazy"
                              }, null, 8, _hoisted_10))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass(["today-event-overlay", { 'today-event-overlay--no-logo': !ev.logoPath }])
                          }, [
                            _createElementVNode("h3", _hoisted_11, _toDisplayString(ev.title), 1),
                            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.formatEventDate(ev.startAt)), 1),
                            _createElementVNode("p", _hoisted_13, _toDisplayString(ev.location || 'Место уточняется'), 1),
                            _createElementVNode("div", _hoisted_14, [
                              (ev.isPaid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Платное"))
                                : _createCommentVNode("", true),
                              (_ctx.isSoldOut(ev))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Sold out"))
                                : _createCommentVNode("", true),
                              (_ctx.isRegistered(ev))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Записан"))
                                : _createCommentVNode("", true)
                            ])
                          ], 2)
                        ], 2),
                        (ev.isPaid && !_ctx.isSoldOut(ev))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "today-event-actions",
                              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _createVNode(_component_ion_button, {
                                expand: "block",
                                class: "today-buy-btn today-accent-btn",
                                fill: "solid",
                                size: "small",
                                onClick: ($event: any) => (_ctx.onPaidEventAction(ev))
                              }, {
                                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                  _createTextVNode(" Оформить участие ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_9))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.upcomingEvents.length === 0 && _ctx.isLoadingEvents ? 4 : 0), (n) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'event-skeleton-' + n,
                        class: "today-event-card today-event-card--skeleton"
                      }, [
                        _createVNode(_component_ion_skeleton_text, {
                          animated: true,
                          class: "today-event-skeleton"
                        })
                      ]))
                    }), 128))
                  ])
                ], 512),
                (_ctx.upcomingEvents.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_router_link, { to: "/events" }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode("Все события →", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : (!_ctx.isLoadingEvents)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "today-empty-text" }, "Нет предстоящих событий.", -1)),
                        _createVNode(_component_router_link, {
                          to: "/events",
                          class: "today-empty-link"
                        }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode("Перейти к событиям", -1)
                          ]))]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.globalContext.offlineMode)
            ? (_openBlock(), _createElementBlock("section", _hoisted_20, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "today-section-head" }, [
                  _createElementVNode("span", {
                    class: "today-section-accent today-section-accent--orange",
                    "aria-hidden": "true"
                  }),
                  _createElementVNode("h2", { class: "today-section-title" }, "Программы")
                ], -1)),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePrograms, (program) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: program.shortName,
                        type: "button",
                        class: "today-program-tile",
                        onClick: ($event: any) => (_ctx.navigateToProgram(program))
                      }, [
                        _createElementVNode("div", _hoisted_24, [
                          (!_ctx.programLogos[program.shortName] && _ctx.isLoadingLogos)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"100%","height":"100%"}
                                })
                              ]))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: _ctx.programLogos[program.shortName] || _ctx.fallbackLogo,
                                alt: program.name,
                                class: "today-program-img",
                                onLoad: ($event: any) => (_ctx.onProgramImageLoad(program.shortName)),
                                onError: ($event: any) => (_ctx.onProgramImageError(program.shortName))
                              }, null, 40, _hoisted_26))
                        ]),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(program.name), 1),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(program.description), 1)
                      ], 8, _hoisted_23))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.globalContext.offlineMode)
            ? (_openBlock(), _createElementBlock("section", _hoisted_29, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "today-section-head" }, [
                  _createElementVNode("span", {
                    class: "today-section-accent",
                    "aria-hidden": "true"
                  }),
                  _createElementVNode("h2", { class: "today-section-title" }, "Тренинги")
                ], -1)),
                (!_ctx.isLoadingShowcase && _ctx.educationSectionsVisible.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_30, " Пока нет разделов "))
                  : (_ctx.educationSectionsVisible.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educationSectionsVisible, (sec) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: 'edu-' + sec.folderKey,
                              type: "button",
                              class: "today-edu-tile",
                              onClick: ($event: any) => (_ctx.onEducationSectionClick(sec))
                            }, [
                              _createElementVNode("span", _hoisted_34, [
                                _createVNode(_component_ion_icon, { icon: _ctx.schoolOutline }, null, 8, ["icon"])
                              ]),
                              _createElementVNode("span", _hoisted_35, _toDisplayString(sec.name), 1)
                            ], 8, _hoisted_33))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                            return _createElementVNode("div", {
                              key: 'edu-skel-' + n,
                              class: "today-edu-tile today-edu-tile--skeleton"
                            }, [
                              _createVNode(_component_ion_skeleton_text, {
                                animated: true,
                                class: "today-edu-skel-icon"
                              }),
                              _createVNode(_component_ion_skeleton_text, {
                                animated: true,
                                class: "today-edu-skel-line"
                              }),
                              _createVNode(_component_ion_skeleton_text, {
                                animated: true,
                                class: "today-edu-skel-meta"
                              })
                            ])
                          }), 64))
                        ])
                      ]))
              ]))
            : _createCommentVNode("", true),
          (_ctx.globalContext.offlineMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.cloudOffline,
                    class: "today-offline-icon"
                  }, null, 8, ["icon"]),
                  _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "today-offline-title" }, "Режим офлайн", -1)),
                  _createVNode(_component_ion_button, {
                    class: "today-reconnect-btn today-accent-btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reconnect())),
                    disabled: _ctx.reconnecting
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.refreshOutline
                      }, null, 8, ["icon"]), [
                        [_vShow, !_ctx.reconnecting]
                      ]),
                      _withDirectives(_createVNode(_component_ion_spinner, { name: "bubbles" }, null, 512), [
                        [_vShow, _ctx.reconnecting]
                      ])
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}